"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canHover = exports.XS_MOBILE_MAX = exports.XL_DESKTOP_MIN_V2 = exports.XL_DESKTOP_MIN = exports.XL_DESKTOP_MAX = exports.TABLET_MIN = exports.TABLET_MAX_V2 = exports.TABLET_MAX = exports.MOBILE_MAX = exports.MASSIVE_DESKTOP_MIN = exports.LG_DESKTOP_MIN_V2 = exports.LG_DESKTOP_MIN = exports.LG_DESKTOP_MAX_V2 = exports.LG_DESKTOP_MAX = exports.DESKTOP_MIN_V2 = exports.DESKTOP_MIN = exports.DESKTOP_MAX_V2 = exports.DESKTOP_MAX = void 0;
exports.isDesktop = isDesktop;
exports.isDesktopV2 = isDesktopV2;
exports.isHighPixelDensity = isHighPixelDensity;
exports.isLargeDesktop = isLargeDesktop;
exports.isLargeDesktopV2 = isLargeDesktopV2;
exports.isMassiveDesktop = isMassiveDesktop;
exports.isMobile = isMobile;
exports.isTablet = isTablet;
exports.isTabletV2 = isTabletV2;
exports.isXlDesktop = isXlDesktop;
exports.isXlDesktopV2 = isXlDesktopV2;
exports.isXsMobile = isXsMobile;
exports.notDesktop = notDesktop;
exports.notDesktopV2 = notDesktopV2;
exports.notLargeDesktop = notLargeDesktop;
exports.notLargeDesktopV2 = notLargeDesktopV2;
exports.notMassiveDesktop = notMassiveDesktop;
exports.notMobile = notMobile;
exports.notTablet = notTablet;
exports.notTabletV2 = notTabletV2;
exports.notXlDesktop = notXlDesktop;
exports.notXlDesktopV2 = notXlDesktopV2;
require("core-js/modules/es.array.concat.js");
var MASSIVE_DESKTOP_MIN = exports.MASSIVE_DESKTOP_MIN = 1920;
var XL_DESKTOP_MAX = exports.XL_DESKTOP_MAX = MASSIVE_DESKTOP_MIN - 1;
var XL_DESKTOP_MIN = exports.XL_DESKTOP_MIN = 1440;
var LG_DESKTOP_MAX = exports.LG_DESKTOP_MAX = XL_DESKTOP_MIN - 1;
var LG_DESKTOP_MIN = exports.LG_DESKTOP_MIN = 1200;
var DESKTOP_MAX = exports.DESKTOP_MAX = LG_DESKTOP_MIN - 1;
var DESKTOP_MIN = exports.DESKTOP_MIN = 992;
var TABLET_MAX = exports.TABLET_MAX = DESKTOP_MIN - 1;
var TABLET_MIN = exports.TABLET_MIN = 768;
var MOBILE_MAX = exports.MOBILE_MAX = TABLET_MIN - 1;
var XS_MOBILE_MAX = exports.XS_MOBILE_MAX = 480;

// MEDIA_QUERY_V2 values (used in most new code)
var XL_DESKTOP_MIN_V2 = exports.XL_DESKTOP_MIN_V2 = 1600;
var LG_DESKTOP_MAX_V2 = exports.LG_DESKTOP_MAX_V2 = XL_DESKTOP_MIN_V2 - 1;
var LG_DESKTOP_MIN_V2 = exports.LG_DESKTOP_MIN_V2 = 1280;
var DESKTOP_MAX_V2 = exports.DESKTOP_MAX_V2 = LG_DESKTOP_MIN_V2 - 1;
var DESKTOP_MIN_V2 = exports.DESKTOP_MIN_V2 = 1024;
var TABLET_MAX_V2 = exports.TABLET_MAX_V2 = DESKTOP_MIN_V2 - 1;

/**
 * @returns true when browser width <= 480px
 */
function isXsMobile() {
  return window.matchMedia("(max-width: ".concat(XS_MOBILE_MAX, "px)")).matches;
}

/**
 * @returns true when browser width <= 767px
 */
function isMobile() {
  return window.matchMedia("(max-width: ".concat(MOBILE_MAX, "px)")).matches;
}

/**
 * @returns true when browser width >= 768px && browser width <= 991px
 * 
 * @deprecated use isTabletV2 (matches MEDIA_QUERY_V2 values)
 */
function isTablet() {
  return window.matchMedia("(min-width: ".concat(TABLET_MIN, "px) and (max-width: ").concat(TABLET_MAX, "px)")).matches;
}

/**
 * @returns true when browser width >= 768px && browser width < 1024px
 */
function isTabletV2() {
  return window.matchMedia("(min-width: ".concat(TABLET_MIN, "px) and (max-width: ").concat(TABLET_MAX_V2, "px)")).matches;
}

/**
 * @returns true when browser width >= 992px
 * 
 * @deprecated use isDesktopV2 (matches MEDIA_QUERY_V2 values)
 */
function isDesktop() {
  return window.matchMedia("(min-width: ".concat(DESKTOP_MIN, "px)")).matches;
}

/**
 * @returns true when browser width >= 1024px
 */
function isDesktopV2() {
  return window.matchMedia("(min-width: ".concat(DESKTOP_MIN_V2, "px)")).matches;
}

/**
 * @returns true when browser width >= 1200px
 * 
 * @deprecated use isLargeDesktop (matches MEDIA_QUERY_V2 values)
 */
function isLargeDesktop() {
  return window.matchMedia("(min-width: ".concat(LG_DESKTOP_MIN, "px)")).matches;
}

/**
 * @returns true when browser width >= 1280px
 */
function isLargeDesktopV2() {
  return window.matchMedia("(min-width: ".concat(LG_DESKTOP_MIN_V2, "px)")).matches;
}

/**
 * @returns true when browser width >= 1440px
 * 
 * @deprecated use isXlDesktop (matches MEDIA_QUERY_V2 values)
 */
function isXlDesktop() {
  return window.matchMedia("(min-width: ".concat(XL_DESKTOP_MIN, "px)")).matches;
}

/**
 * @returns true when browser width >= 1600px
 */
function isXlDesktopV2() {
  return window.matchMedia("(min-width: ".concat(XL_DESKTOP_MIN_V2, "px)")).matches;
}

/**
 * @returns true when browser width >= 1920px
 */
function isMassiveDesktop() {
  return window.matchMedia("(min-width: ".concat(MASSIVE_DESKTOP_MIN, "px)")).matches;
}

/**
 * @returns true when browser width >= 768px
 */
function notMobile() {
  return window.matchMedia("(min-width: ".concat(TABLET_MIN, "px)")).matches;
}

/**
 * @returns true when browser width >= 992px OR browser width <= 767px
 * 
 * @deprecated use notTabletV2 (matches MEDIA_QUERY_V2 values)
 */
function notTablet() {
  return window.matchMedia("(max-width: ".concat(MOBILE_MAX, "px), (min-width: ").concat(DESKTOP_MIN, "px)")).matches;
}

/**
 * @returns true when browser width >= 1024px OR browser width < 768px
 */
function notTabletV2() {
  return window.matchMedia("(max-width: ".concat(MOBILE_MAX, "px), (min-width: ").concat(DESKTOP_MIN_V2, "px)")).matches;
}

/**
 * @returns true when browser width < 992px
 * 
 * @deprecated use notDesktopV2 (matches MEDIA_QUERY_V2 values)
 */
function notDesktop() {
  return window.matchMedia("(max-width: ".concat(TABLET_MAX, "px)")).matches;
}

/**
 * @returns true when browser width < 1024px
 */
function notDesktopV2() {
  return window.matchMedia("(max-width: ".concat(TABLET_MAX_V2, "px)")).matches;
}

/**
 * @returns true when browser width < 1200px
 * 
 * @deprecated use notLargeDesktopV2 (matches MEDIA_QUERY_V2 values)
 */
function notLargeDesktop() {
  return window.matchMedia("(max-width: ".concat(DESKTOP_MAX, "px)")).matches;
}

/**
 * @returns true when browser width < 1280px
 */
function notLargeDesktopV2() {
  return window.matchMedia("(max-width: ".concat(DESKTOP_MAX_V2, "px)")).matches;
}

/**
 * @returns true when browser width < 1440px
 * 
 * @deprecated use notXlDesktopV2 (matches MEDIA_QUERY_V2 values)
 */
function notXlDesktop() {
  return window.matchMedia("(max-width: ".concat(LG_DESKTOP_MAX, "px)")).matches;
}

/**
 * @returns true when browser width < 1600px
 */
function notXlDesktopV2() {
  return window.matchMedia("(max-width: ".concat(LG_DESKTOP_MAX_V2, "px)")).matches;
}

/**
 * @returns true when browser width < 1920px
 */
function notMassiveDesktop() {
  return window.matchMedia("(max-width: ".concat(XL_DESKTOP_MAX, "px)")).matches;
}
function isHighPixelDensity() {
  return window.matchMedia('(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)').matches;
}

/**
 * @returns true when the device supports hover
 */
var canHover = exports.canHover = function canHover() {
  return window.matchMedia('(hover: hover)').matches;
};